import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core'
import {DateFormatService, RichsnipetService} from 'dmmp-services'
import {RemoveHtmlPipe} from '../../pipes/removeHtml.pipe'
import {map} from 'rxjs/operators'
import { MediaInterface } from '../../interfaces'

@Component({
  selector: 'dmmp-website-box-float-program-v2',
  templateUrl: './website-box-float-program-v2.component.html'
})
export class WebsiteBoxFloatProgramV2Component implements OnInit {
  @Input() identifier
  @Input() detailLayout
  @Input() module
  @Input() university
  @Input() duration = 'Duración:'
  @Input() title = 'Título:'
  @Input() titleComplementary = 'Titulo complementario:'
  @Input() doubleDegree = 'Doble titulación posible:'
  @Input() titleIntermediate = 'Título intermedio (3 años):'
  @Input() modalityText = 'Modalidad:'
  @Input() campusText = 'Sede:'
  @Input() resolutionText = 'Resolución Ministerial:'
  @Output() page = new EventEmitter()
  @Output() anchorCustom = new EventEmitter()
  classScroll: boolean
  classScrollMobile: boolean
  openModal: boolean
  schemaItemVideo = []
  schemaItem = []
  description

  medias : MediaInterface[] = [
    {style: 'max_650x650', media: '(max-width:650px) AND (min-width:326px)'},
    {style: 'max_325x325', media: '(max-width:325px)'},
  ]

  constructor(
    private dateService: DateFormatService,
    private richsnipetService: RichsnipetService,
    private removeHtmlPipe: RemoveHtmlPipe) {
  }

  ngOnInit() {
    if (this.detailLayout && this.detailLayout.video_box && this.detailLayout.video_box.length > 0) {
      if (this.detailLayout.video_box[0].type === 'youtube') {
        const video = this.detailLayout.video_box[0].video[0].value
        this.richsnipetService.getInfoVideo((video.substr(video.indexOf('v=') + 2, video.length))).pipe(
          map((data: any) => {
            if (data) {
              this.createRichSnipet(data.items[0].contentDetails.duration)
            }
          })
        ).subscribe()
      } else {
        this.createRichSnipet()
      }
    }
    if (this.detailLayout) {
      if (this.detailLayout.items && this.detailLayout.items.length > 0) {
        this.description = this.detailLayout.items[0].options.find(tabs => {
          if (tabs.identifier === 'textos') {
            return tabs.text
          }
        })
      }
      this.schemaItem = this.richsnipetService.setupJsonCourse([{
        title: this.detailLayout.title ? this.detailLayout.title : '',
        description: this.description ? this.removeHtmlPipe.transform(this.description.text) : '',
        university: [{title: this.university ? this.university : ''}],
      }])
    }
  }

  createRichSnipet(duration: string = '') {
    this.schemaItemVideo = this.richsnipetService.setupJsonVideo(
      this.detailLayout.video_box[0].title ? this.detailLayout.video_box[0].title : '',
      this.detailLayout.video_box[0].description ? this.removeHtmlPipe.transform(this.detailLayout.video_box[0].description) : '',
      this.detailLayout.video_box[0].image && this.detailLayout.video_box[0].image.length > 0 && this.detailLayout.video_box[0].image[0].styles.large ? this.detailLayout.video_box[0].image[0].styles.large : '',
      this.detailLayout.video_box[0].created_at ? this.dateService.convertFromTimestampToDate(this.detailLayout.video_box[0].created_at) : '',
      this.detailLayout.video_box[0].video[0].value ? this.detailLayout.video_box[0].video[0].value : '',
      duration)
  }

  @HostListener('window:scroll', [])
  public onScrollEvent(): void {
    const header = document.querySelector('header')
    const heightHeader = header ? header.offsetHeight : 64
    this.classScroll = window.scrollY > heightHeader + 120
    this.classScrollMobile = window.scrollY > 0
  }
}
